import { useEffect, useState } from "react";
import Typography from "@material-ui/core/Typography";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import CircularProgress from "@mui/material/CircularProgress";
import toast from "react-hot-toast";
import { useLoaderData, useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import "./PastBerths.css";
import { getPastBerths } from "../../../../../services/berth";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TablePagination from "@mui/material/TablePagination";
import Alert from "@mui/material/Alert";

const useStyles = makeStyles((theme) => ({
  cont: {
    background: "white",
    width: "100%",
    margin: "auto",
    marginTop: "20px",
    borderRadius: "10px",
    overflow: "hidden",
    marginBottom: "20px",
    boxShadow:
      "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
  },
  dealerHeading: {
    fontSize: "24px",
    marginBottom: "24px",
    marginTop: "12px",
  },
  tableContain: {
    padding: "30px",
  },
}));

export const PastBerths = () => {
  const user = useLoaderData();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const classes = useStyles();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const getOrders = async () => {
    setLoading(true);
    const res = await getPastBerths(user?.token);
    // console.log("res: ", res);

    if (res?.status === true) {
      setOrders(res?.data);
      setLoading(false);
      return;
    }

    if (res?.status === false) {
      if (res?.message === "no past berths found") {
        toast.error("Past berths not found");
        setOrders([]);
        setLoading(false);
        return;
      }

      if (res?.message === "Invalid or expired access token.") {
        toast.error("Token expired, please re-login and try");
        setOrders([]);
        setLoading(false);
        return;
      }

      toast.error("Something went wrong please try later");
      setOrders([]);
      setLoading(false);
      return;
    }

    toast.error("Something went wrong please try later");
    setOrders([]);
    setLoading(false);
    return;
  };

  useEffect(() => {
    getOrders();
  }, []);

  return (
    <>
      <div className={classes.cont}>
        <div className={classes.tableContain}>
          <Typography
            variant="h5"
            component="h5"
            className={classes.dealerHeading}
          >
            Berth History
          </Typography>
          <div className={classes.table}>
            {loading === true ? (
              <div className="loaderParent">
                <CircularProgress size={40} />
              </div>
            ) : (
              <>
                {orders.length === 0 ? (
                  <div className="loaderParent">
                    <h2>Past berths not found!</h2>
                  </div>
                ) : (
                  <>
                    <TableContainer component={Paper}>
                      <Table sx={{ minWidth: 650 }} aria-label="simple table">
                        <TableHead>
                          <TableRow>
                            <TableCell>Berth Name</TableCell>
                            <TableCell>Berth Location</TableCell>
                            <TableCell>Request Type</TableCell>
                            <TableCell align="right">Total Amount</TableCell>
                            <TableCell>Requested At</TableCell>
                            <TableCell align="right">Status</TableCell>
                            <TableCell>Rejection Reason</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {orders
                            .slice(
                              page * rowsPerPage,
                              page * rowsPerPage + rowsPerPage
                            )
                            .map((order, key) => (
                              <TableRow
                                key={key}
                                sx={{
                                  "&:last-child td, &:last-child th": {
                                    border: 0,
                                  },
                                }}
                              >
                                <TableCell component="th" scope="row">
                                  {order?.sourceBerth?.name}
                                </TableCell>
                                <TableCell>
                                  {order?.sourceBerth?.currentLocation?.name}
                                </TableCell>
                                <TableCell>
                                  <>
                                    <label
                                      className={`pastOrdersCardTypeBox ${
                                        order?.transactionType
                                          ? order?.transactionType ===
                                            "hire or swap"
                                            ? "hireOrSwap"
                                            : order?.transactionType
                                          : "hireOrSwap"
                                      }`}
                                    >
                                      {order?.transactionType
                                        ? order?.transactionType
                                        : "--"}
                                    </label>
                                  </>
                                </TableCell>
                                <TableCell align="right">
                                  {
                                    order && order?.transactionType.toLowerCase() === "swap" 
                                    ? "--" 
                                    : order?.totalAmount
                                  }
                                </TableCell>
                                <TableCell>
                                  {dayjs(
                                    order?.createdAt ? order?.createdAt : null
                                  ).format("YYYY-MM-DD")}
                                </TableCell>
                                <TableCell align="right">
                                  <span className={order?.currentStatus}>
                                    {order?.currentStatus}
                                  </span>
                                </TableCell>
                                <TableCell>
                                  {order?.currentStatus === "rejected" && order?.cancellationReason ? (
                                    // <Alert severity="error" sx={{ fontSize: '0.875rem' }}>
                                      order.cancellationReason
                                    // </Alert>
                                  ) : (
                                    "--"
                                  )}
                                </TableCell>
                              </TableRow>
                            ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                    <TablePagination
                      rowsPerPageOptions={[10, 20, 50, 100]}
                      component="div"
                      count={orders.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                  </>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
